import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import type { ReactNode } from "react";
import React, { useEffect, useState } from "react";

dayjs.extend(duration);

interface MarketCountdownProps {
  openDate: Date;
  className?: string;
}

const COUNTDOWN_UPDATE_INTERVAL_MS = 1000;

const MarketCountdown: React.FC<MarketCountdownProps> = ({
  openDate,
  className,
}) => {
  const [countdown, setCountdown] = useState<ReactNode>("Calculating...");

  useEffect(() => {
    const updateCountdown = () => {
      const now = dayjs();
      const target = dayjs(openDate);
      const diffInSeconds = target.diff(now, "second");

      if (diffInSeconds > 0) {
        const totalDays = target.diff(now, "day");
        const remainingTime = dayjs.duration(diffInSeconds * 1000);

        const parts = [];

        if (totalDays > 0) parts.push(`${totalDays}d`);
        if (remainingTime.hours() > 0) parts.push(`${remainingTime.hours()}h`);
        if (remainingTime.minutes() > 0)
          parts.push(`${remainingTime.minutes()}m`);

        parts.push(`${remainingTime.seconds()}s`);

        setCountdown(
          <>
            Market opens in <span className="font-mono">{parts.join(" ")}</span>
          </>,
        );
      } else {
        setCountdown("Market is open!");
        clearInterval(interval);
      }
    };

    const interval = setInterval(updateCountdown, COUNTDOWN_UPDATE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [openDate]);

  return <div className={className}>{countdown}</div>;
};

export default MarketCountdown;
